/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Loader } from '@insticator/insticator-ui';
// styles
import injectSheet from 'react-jss';
import styles from './loading_styles';



/* ========== ~~~~~~~~~~ LOADING - STATE ~~~~~~~~~~ ========== */
const LoadingState = injectSheet(styles)((props) => {
	return (
		<div className={`loadercontainer ${props.classes.loadingstate}`}>
			<Loader />
		</div>
	);
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default LoadingState;
